import { Component, Vue, PropSync, Watch, Emit } from 'vue-property-decorator';
import { ApiIdentifers } from '@/config/index';
import { ConfigurationField } from '@/models/configuration/Field';
import { TableDataSet } from '@/models/tableDataset/TableDataSet';
import { TableDataSetField } from '@/models/tableDataset/TableDataSetField';
import { TableDataSetSection } from '@/models/tableDataset/TableDataSetSection';
import { DataSetStore } from '@/store/store.dataSet';
import { FieldTypeEnum } from '@/enums/FieldTypeEnums';
import { UnitsHelper, LoggerService, UtilsHelper } from '@/utils';
import { TableClickEvent } from '@/models/tables/TableClickEvent';
import { TableMenuActionColorEnums } from '@/enums/TableMenuActionEnums';
import { DataSet } from '@/models/dataset/DataSet';
import { DataSetSection } from '@/models/dataset/DataSetSection';
import { DataSetField } from '@/models/dataset/DataSetField';
import { Helpers } from '@/helpers/Helpers';
import { ConfigurationService } from '@/services';
import countries from '@/assets/countries.json';

@Component({
    filters: {
        filterUnitFormatFields(fields: TableDataSetField[]) {
            return fields.filter((f) => f.type !== FieldTypeEnum.UNIT);
        },
    },
})
export default class TableItemComponent extends Vue {
    @PropSync('dataSet', { type: Object }) public syncedDataSet!: DataSet;
    @PropSync('tableDataSet', { type: Object }) public syncedTableDataSet!: TableDataSet;
    @PropSync('section', { type: String }) public syncedSection!: string;
    @PropSync('subSection', { type: String }) public syncedSubSection!: string;
    @PropSync('subSampleSection', { type: String }) public syncedSubSampleSection!: string;
    @PropSync('listRef', { type: Object }) public syncedListRef!: Vue;

    @PropSync('selectedDataSetId', { type: String }) public syncedSelectedDataSetId!: string;
    @PropSync('selectedCellId', { type: String }) public syncedSelectedCellId!: string;

    @PropSync('fixed', { type: Boolean }) public syncedFixed!: boolean;
    @PropSync('changed', { type: Boolean }) public syncedChanged!: boolean;

    public fields: TableDataSetField[] = [];

    public identifers: any = ApiIdentifers;

    private selectedFields: DataSetField[] = [];
    private selectedSection?: DataSetSection;
    private selectedSample?: DataSetField;

    // tslint:disable-next-line: no-empty
    public mounted() {
        // LoggerService.LogDebug(`TableItem mounted: ${this.syncedDataSet.id}`);
        if (this.syncedDataSet) {
            this.GetFields();
        }
    }

    public beforeDestroy() {
        // LoggerService.LogDebug(`TableItem beforeDestroy: ${this.syncedDataSet.id}`);
    }

    public destroyed() {
        // LoggerService.LogDebug(`TableItem destroyed: ${this.syncedDataSet.id}`);
    }

    @Watch('syncedDataSet', { deep: true })
    public onSyncedDataSetChanged(newValue: DataSet) {
        // LoggerService.LogDebug(`TableItemComponent onSyncedTableDataSetChanged: `, newValue);
        if (this.syncedDataSet) {
            this.GetFields();
        }
    }

    @Watch('syncedSection')
    public onSyncedSectionChanged(newValue: string) {
        // LoggerService.LogDebug(`onSyncedSectionChanged: ${newValue}`);
        this.GetFields();
    }

    @Watch('syncedSubSampleSection')
    public onSyncedSubSampleSectionChanged(newValue: string) {
        // LoggerService.LogDebug(`onSyncedSubSectionChanged: ${newValue}`);
        this.GetFields();
    }

    @Watch('syncedSubSection')
    public onSyncedSubSectionChanged(newValue: string) {
        // LoggerService.LogDebug(`onSyncedSubSectionChanged: ${newValue}`);
        this.GetFields();
    }

    @Emit('itemClicked')
    public emitItemClicked(event: TableClickEvent) {
        return event;
    }

    @Emit('itemDbClicked')
    public emitItemDbClicked(dataSetId: string) {
        return dataSetId;
    }

    public onItemClicked(event: MouseEvent, field: TableDataSetField) {
        const element = event.currentTarget as HTMLDivElement;
        const offsetParent = element.offsetParent as HTMLDivElement;
        let disableEdit = field.type === FieldTypeEnum.AXSELECT || field.type === FieldTypeEnum.DATETIME;
        const section = this.syncedTableDataSet.sections.find((sec) => sec.identifier === this.syncedSection);
        if (section && section.identifier === ApiIdentifers.general) {
            if (
                field.identifier === ApiIdentifers.notesInputText ||
                field.identifier === ApiIdentifers.generalCreatedBy ||
                field.identifier === ApiIdentifers.generalCreatedAt ||
                field.identifier === ApiIdentifers.generalEditedBy ||
                field.identifier === ApiIdentifers.generalEditedAt ||
                field.identifier === ApiIdentifers.generalMyMillTimestamp
            ) {
                disableEdit = true;
            }
        }
        /**
         * calculate position where the row menu should be shown
         */
        this.emitItemClicked(
            new TableClickEvent({
                dataSetId: this.syncedDataSet.dataSetId || '',
                dataSetCellId: field.identifier,
                dataSetCellValue: this.getFieldValue(field, this.fields),
                positionX: element.offsetLeft + offsetParent.offsetLeft - this.syncedListRef.$el.scrollLeft + element.offsetWidth / 2,
                positionY: element.offsetTop + offsetParent.offsetTop - this.syncedListRef.$el.scrollTop + element.offsetHeight / 2,
                isFixed: false,
                disableEdit,
            }),
        );
    }

    public onItemDbCLicked(event: MouseEvent) {
        this.emitItemDbClicked(this.syncedDataSet.dataSetId || '');
    }

    public GetFields() {
        const section = this.syncedTableDataSet.sections.find((sec) => sec.identifier === this.syncedSection);
        const self = this;

        this.selectedSection = undefined;
        this.selectedSample = undefined;

        this.selectedSection = this.syncedDataSet.sections.find((sec) => sec.identifier === this.syncedSection);

        this.fields = [];
        this.selectedFields = [];

        if (section !== undefined) {
            if (this.syncedSubSection === undefined || this.syncedSubSection.length === 0 || this.syncedSubSection === this.syncedSection) {
                this.fields = section.fields.filter((field) => field.fields === undefined);
                this.selectedFields = (this.selectedSection && this.selectedSection.fields.filter((field) => field.fields === undefined)) || [];
                if (section.identifier === ApiIdentifers.general) {
                    // add notes field manual to general section
                    const notes = this.syncedDataSet.sections.find((sec) => sec.identifier === ApiIdentifers.notes);
                    let notesInputText: DataSetField | undefined;
                    if (notes != null) {
                        notesInputText = notes.fields.find((f) => f.identifier === ApiIdentifers.notesInputText);
                    }
                    this.fields.push(UtilsHelper.generateUserTableDataSetField(ApiIdentifers.notesInputText, 'Input text', FieldTypeEnum.TEXTAREA));
                    // add manual items for creator/editor
                    this.fields.push(UtilsHelper.generateUserTableDataSetField(ApiIdentifers.generalCreatedBy, 'Created by', FieldTypeEnum.TEXT));
                    this.fields.push(UtilsHelper.generateUserTableDataSetField(ApiIdentifers.generalCreatedAt, 'Created at', FieldTypeEnum.DATE));
                    this.fields.push(UtilsHelper.generateUserTableDataSetField(ApiIdentifers.generalEditedBy, 'Modified by', FieldTypeEnum.TEXT));
                    this.fields.push(UtilsHelper.generateUserTableDataSetField(ApiIdentifers.generalEditedAt, 'Modified at', FieldTypeEnum.DATE));
                    this.fields.push(UtilsHelper.generateUserTableDataSetField(ApiIdentifers.generalMyMillTimestamp, 'MyMill Date', FieldTypeEnum.DATE));

                    if (notesInputText != null) {
                        this.selectedFields.push(notesInputText);
                    } else {
                        this.selectedFields.push(UtilsHelper.generateUserDataSet(ApiIdentifers.notesInputText, '-'));
                    }
                    this.selectedFields.push(UtilsHelper.generateUserDataSet(ApiIdentifers.generalCreatedBy, this.syncedDataSet.created.userName));
                    this.selectedFields.push(UtilsHelper.generateUserDataSet(ApiIdentifers.generalCreatedAt, this.syncedDataSet.created.date));
                    this.selectedFields.push(UtilsHelper.generateUserDataSet(ApiIdentifers.generalEditedBy, this.syncedDataSet.lastModified && this.syncedDataSet.lastModified.userName));
                    this.selectedFields.push(UtilsHelper.generateUserDataSet(ApiIdentifers.generalEditedAt, this.syncedDataSet.lastModified && this.syncedDataSet.lastModified.date));
                    this.selectedFields.push(UtilsHelper.generateUserDataSet(ApiIdentifers.generalMyMillTimestamp, this.syncedDataSet.myMillImport && this.syncedDataSet.myMillImport.extractionDate));
                }
            } else {
                let fields = section.fields;
                let dataFields = (this.selectedSection && this.selectedSection.fields) || [];

                if (this.syncedSubSampleSection !== '') {
                    // in case we have more sample subSections
                    const subSampleSection = this.syncedSubSampleSection.replace(/__[0-9]*/, '__0');

                    const sample = section.fields.find((field) => field.identifier === subSampleSection);
                    this.selectedSample = this.selectedSection && this.selectedSection.fields.find((field) => field.identifier === this.syncedSubSampleSection);
                    if (sample !== undefined && sample.fields !== undefined) {
                        fields = sample.fields;
                        dataFields = (this.selectedSample && this.selectedSample.fields) || [];
                    } else {
                        fields.splice(0, fields.length);
                        dataFields.splice(0, dataFields.length);
                        this.fields = [];
                    }
                }

                for (const field of fields) {
                    let dataIdentifier = field.identifier;
                    /**
                     * If we are at materials or contacts we need to use syncedSubSection.
                     * But in any other case we need to use the field identifier
                     */
                    if (
                        (this.syncedSection === ApiIdentifers.material || this.syncedSection === ApiIdentifers.contacts) &&
                        Helpers.undef(this.syncedSubSection) === false &&
                        Helpers.undef(this.syncedSubSampleSection) === true
                    ) {
                        dataIdentifier = this.syncedSubSection;
                    }
                    const dataField = dataFields.find((df) => df.identifier === dataIdentifier);
                    const subFieldSection = this.getSubFields(field, this.syncedSubSection, dataField);
                    if (subFieldSection !== undefined && subFieldSection.tableFields.length > 0) {
                        this.fields = subFieldSection.tableFields;
                        this.selectedFields = subFieldSection.dataFields;
                        break;
                    }
                    this.fields = [];
                    this.selectedFields = [];
                }
                // Fillup empty stuff, e.g. materials
                if (this.syncedSubSection !== undefined && this.fields.length === 0 && section.action !== undefined) {
                    this.fields = this.getTempSubFields(section, this.syncedSubSection);
                }
            }
        }
    }

    /**
     * Method that filters fields which should not be shown in the table view
     * filtered fields:
     *  - all unit format fields (the unit format is shown in the header)
     *  - general section unit format
     * @param fields
     * @returns
     */
    public getfilterUnitFormatFields(fields: ConfigurationField[]) {
        return fields.filter((f) => f.type !== FieldTypeEnum.UNIT && f.identifier !== ApiIdentifers.generalUnitFormat);
    }

    public getHidden(): boolean {
        return this.syncedFixed === false && this.syncedDataSet.fixedRow === true;
    }

    public getClasses(field: TableDataSetField): string {
        const classes: string[] = [];
        const dataField = this.selectedFields.find((df) => df.identifier === field.identifier);

        if (field.identifier === ApiIdentifers.notesInputText) {
            if (this.syncedSection === ApiIdentifers.notes) {
                classes.push('big');
            } else {
                classes.push('medium');
                if (dataField && dataField.valueString != null && dataField.valueString !== '-') {
                    classes.push('left');
                }
            }
        }

        if (this.syncedDataSet.dataSetId === this.syncedSelectedDataSetId && dataField !== undefined && dataField.identifier === this.syncedSelectedCellId) {
            classes.push('selected');
        }

        if (dataField !== undefined && dataField.color !== undefined) {
            switch (dataField.color) {
                case TableMenuActionColorEnums.ORANGE:
                    classes.push('orange');
                    break;
                case TableMenuActionColorEnums.GREY:
                    classes.push('grey');
                    break;
                case TableMenuActionColorEnums.BLUE:
                    classes.push('blue');
                    break;
                case TableMenuActionColorEnums.UNMARK:
                default:
                    break;
            }
        }

        if (dataField !== undefined && this.syncedChanged === true && dataField.changed === true) {
            classes.push('bold');
        }

        return classes.join(' ');
    }

    public getUseToolTip(field: TableDataSetField): boolean {
        let useTT = false;
        if (field.identifier === ApiIdentifers.notesInputText) {
            if (this.syncedSection === ApiIdentifers.notes) {
                useTT = true;
            } else {
                useTT = true;
            }
        } else if (field.identifier === ApiIdentifers.cardClothingFurtherInformation) {
            if (this.syncedSection === ApiIdentifers.carding && this.syncedSubSection === ApiIdentifers.cardClothing) {
                useTT = true;
            } else {
                useTT = true;
            }
        } else if (field.identifier === ApiIdentifers.generalTrialDate) {
            if (this.syncedSection === ApiIdentifers.general) {
                useTT = true;
            } else {
                useTT = false;
            }
        } else if (field.identifier === ApiIdentifers.generalMyMillTimestamp) {
            if (this.syncedSection === ApiIdentifers.general) {
                useTT = true;
            } else {
                useTT = false;
            }
        }

        return useTT;
    }

    public getFieldValue(inField: TableDataSetField, inFieldsWithUnit: TableDataSetField[], isToolTip: boolean = false): string {
        let value = '-';
        const fieldData = this.selectedFields.find((field) => field.identifier === inField.identifier);

        if (fieldData && fieldData.valueBool !== undefined) {
            value = fieldData.valueBool ? 'yes' : 'no';
        } else if (fieldData && fieldData.valueNumber != null) {
            if (inField.type === FieldTypeEnum.NUMBER) {
                // Fineness: show stored value + row unit format (e.g. "10.00 µm"); do not convert by profile
                if (inField.identifier === ApiIdentifers.materialFineness) {
                    value = inField.rangeStep
                        ? fieldData.valueNumber.toFixed(UnitsHelper.getPrecision(inField.rangeStep))
                        : fieldData.valueNumber.toString();
                    const finenessFormat = this.getFinenessFormatLabel(inField, inFieldsWithUnit);
                    if (finenessFormat) {
                        value = `${value} ${finenessFormat}`;
                    }
                } else if (inField.unit !== undefined && inField.unit !== ApiIdentifers.unitTemperature) {
                    const unitField = inFieldsWithUnit.find((x) => x.identifier === inField.unit);
                    if (unitField !== undefined && unitField.unitIdentifier !== undefined) {
                        value = UnitsHelper.calcByUnit(unitField.unitIdentifier, inField.rangeStep, fieldData.valueNumber, unitField.valueNumber || undefined);
                    }
                } else if (inField.unit !== undefined && inField.unit === ApiIdentifers.unitTemperature) {
                    // handle temperature extra, format is selected by user profile
                    value = UnitsHelper.calcByUnit(inField.unit, inField.rangeStep, fieldData.valueNumber, 0);
                } else {
                    value = inField.rangeStep ? fieldData.valueNumber.toFixed(UnitsHelper.getPrecision(inField.rangeStep)) : fieldData.valueNumber.toString();
                }
            } else if (inField.type === FieldTypeEnum.SELECT) {
                if (inField.values !== undefined && inField.values.length > 0) {
                    const fieldValue = inField.values.find((x) => x.value === fieldData.valueNumber);
                    value = (fieldValue && fieldValue.text) || fieldData.valueNumber.toString();
                }
            } else if (inField.type === FieldTypeEnum.AXSELECT) {
                if (inField.axValues !== undefined && inField.axValues.length > 0) {
                    const fieldValue = inField.axValues.find((x) => x.value === fieldData.valueString);
                    value = (fieldValue && fieldValue.text) || fieldData.valueString || '';
                }
            } else if (inField.type === FieldTypeEnum.UNIT) {
                const unit = ConfigurationService.GetUnitsConfiguration.sections.find((sec) => sec.identifier === inField.unitIdentifier);
                if (unit !== undefined && unit.values) {
                    value = unit.values[fieldData.valueNumber].text;
                }
            } else {
                value = fieldData.valueNumber.toString();
            }
        } else if (fieldData && fieldData.valueString !== undefined) {
            if (inField.identifier === ApiIdentifers.generalTrialDate || inField.identifier === ApiIdentifers.generalEditedAt || inField.identifier === ApiIdentifers.generalCreatedAt) {
                value = Helpers.getFormattedDateString(fieldData.valueString);
                if (isToolTip) {
                    value += ` ${Helpers.getFormattedTimeString(fieldData.valueString)}`;
                }
            } else if (inField.identifier === ApiIdentifers.generalMyMillTimestamp) {
                const datetimeField = this.selectedFields.find((field) => field.identifier === ApiIdentifers.generalMyMillTimestamp);
                if (datetimeField && datetimeField.valueString) {
                    if (isToolTip) {
                        value = Helpers.getExportDateTimeString(datetimeField.valueString, 'en-GB', true);
                    } else {
                        value = Helpers.getFormattedDateString(datetimeField.valueString);
                    }
                }
            } else if (inField.identifier === ApiIdentifers.axCountry) {
                const country = countries.find((c: any) => c.id === fieldData.valueString);
                if (country) {
                    value = country.name;
                }
            } else {
                value = fieldData.valueString;
            }
        } else if (inField.identifier === ApiIdentifers.generalTrialTime) {
            /**
             * Trial time is not saved as a single field but instead in trial date value
             * So we just get the value from trial date for showing here.
             */
            const datetimeField = this.selectedFields.find((field) => field.identifier === ApiIdentifers.generalTrialDate);
            if (datetimeField && datetimeField.valueString) {
                value = Helpers.getFormattedTimeString(datetimeField.valueString);
            }
        }

        return value;
    }

    /**
     * Resolves Fineness unit label (dtex/den/MIC/µm) for the subprocess row.
     * Prefer the stored Fineness Unit so old datasets stay historically honest in table view.
     * Fall back to Material Component mapping when no unit was saved.
     */
    private getFinenessFormatLabel(inField: TableDataSetField, inFieldsWithUnit: TableDataSetField[]): string {
        const unitFieldId = inField.unit || ApiIdentifers.materialFinenessUnit;
        let formatValue: number | undefined;

        const unitData = this.selectedFields.find((field) => field.identifier === unitFieldId);
        if (unitData != null && unitData.valueNumber != null) {
            formatValue = unitData.valueNumber;
        }

        if (formatValue == null) {
            const materialComponent = this.selectedFields.find((field) => field.identifier === ApiIdentifers.materialComponent);
            if (materialComponent != null && materialComponent.valueNumber != null) {
                formatValue = this.getFinenessUnitForMaterialComponent(materialComponent.valueNumber);
            }
        }

        if (formatValue == null) {
            return '';
        }

        const unitField = inFieldsWithUnit.find((x) => x.identifier === unitFieldId);
        const unitIdentifier = (unitField && unitField.unitIdentifier) || ApiIdentifers.unitFineness;
        const unitConfig = ConfigurationService.GetUnitsConfiguration.sections.find((sec) => sec.identifier === unitIdentifier);
        if (unitConfig === undefined || unitConfig.values === undefined) {
            return '';
        }

        const unitValue = unitConfig.values.find((v) => v.value === formatValue);
        return (unitValue && unitValue.text) || '';
    }

    /**
     * Same mapping as edit Field.ts: Cotton→MIC, Man-Made→den, Animal/Other plant/Other→µm
     */
    private getFinenessUnitForMaterialComponent(materialComponentValue: number): number | undefined {
        // units.json 9877fa39: dtex=0, den=1, MIC=2, µm=3
        const cotton = [1];
        const manMadeFibres = [0, 3, 4, 5, 6, 7, 11, 12, 13, 14, 15, 18];
        const micron = [10, 16, 17];

        if (cotton.indexOf(materialComponentValue) >= 0) {
            return 2; // MIC
        }
        if (manMadeFibres.indexOf(materialComponentValue) >= 0) {
            return 1; // den
        }
        if (micron.indexOf(materialComponentValue) >= 0) {
            return 3; // µm
        }
        return undefined;
    }

    private getSubFields(
        inField: TableDataSetField,
        inSubSectionId: string,
        inDataSetFields?: DataSetField,
    ): {
        tableFields: TableDataSetField[];
        dataFields: DataSetField[];
    } {
        let tableFields: TableDataSetField[] = [];
        let dataFields: DataSetField[] = [];
        // in case we have a action field sub section
        const tableSubSectionId = inSubSectionId.replace(/__[0-9]*/, '__0');

        if (inField.fields !== undefined) {
            if (inField.identifier === tableSubSectionId) {
                tableFields = inField.fields.filter((field) => field.fields === undefined);
                dataFields = (inDataSetFields && inDataSetFields.fields && inDataSetFields.fields.filter((field) => field.fields === undefined)) || [];
            } else {
                const subSection = inField.fields.find((field) => field.identifier === inSubSectionId);
                const subSectionData = inDataSetFields && inDataSetFields.fields && inDataSetFields.fields.find((field) => field.identifier === inSubSectionId);
                if (subSection !== undefined) {
                    tableFields = subSection.fields || [];
                    dataFields = (subSectionData && subSectionData.fields) || [];
                } else {
                    for (const subField of inField.fields) {
                        const subFieldData = inDataSetFields && inDataSetFields.fields && inDataSetFields.fields.find((field) => field.identifier === subField.identifier);
                        const subFieldSection = this.getSubFields(subField, inSubSectionId, subFieldData);
                        if (subFieldSection !== undefined && subFieldSection.tableFields.length > 0) {
                            tableFields = subFieldSection.tableFields;
                            dataFields = subFieldSection.dataFields;
                            break;
                        }
                    }
                }
            }
        }

        return { tableFields, dataFields };
    }

    private getTempSubFields(inField: TableDataSetSection, inSubSectionIdentifier?: string): TableDataSetField[] {
        let tempData: TableDataSetField[] = [];
        const data = DataSetStore.GetTempTableItems;

        switch (inField.identifier) {
            case ApiIdentifers.material:
                const material = data.find((sec) => sec.identifier === ApiIdentifers.material);
                tempData = (material && material.fields) || [];
                break;
            case ApiIdentifers.contacts:
                const contacts = data.find((sec) => sec.identifier === ApiIdentifers.contacts);
                tempData = (contacts && contacts.fields) || [];
                break;
            case ApiIdentifers.sample:
                const samples = data.find((sec) => sec.identifier === ApiIdentifers.sample);
                const sampleSection = samples!.fields.find((field) => field.identifier === inSubSectionIdentifier);
                if (sampleSection !== undefined) {
                    tempData = ((sampleSection && sampleSection.fields) || []).filter((field) => field.fields === undefined);
                } else if (samples && inSubSectionIdentifier) {
                    tempData = this.findSubSection(samples.fields, inSubSectionIdentifier);
                } else {
                    tempData.splice(0, tempData.length);
                }
                break;
            default:
                break;
        }

        return tempData;
    }

    private findSubSection(inFields: TableDataSetField[], inSubSectionIdentifier: string): TableDataSetField[] {
        let tempData: TableDataSetField[] = [];

        for (const field of inFields) {
            if (field.identifier === inSubSectionIdentifier) {
                tempData = field.fields || [];
                break;
            }
            if (field.fields !== undefined) {
                tempData = this.findSubSection(field.fields, inSubSectionIdentifier);
            }
        }

        return tempData;
    }
}
